import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.searchCondition.loading;
export const selectErrorMessage = (state: RootState) =>
  state.searchCondition.error;
export const searchConditionDataResponse = (state: RootState) =>
  state.searchCondition.searchConditionResponse;
